import { get, post } from "sr/utils/axios";

export const getCheckrPackages = async () =>
  get<any>("/checkr/packages");

export const getCompanyLatestBackgroundCheck = async (contractorId: string) =>
  get<any>(`/checkr/company/${contractorId}/latest`);

export const downloadCompanyBackgroundCheckReport = async (
  contractorId: string,
) => get<any>(`/checkr/company/${contractorId}/report`);

export const downloadCompanyBackgroundCheckReportDocument = async (
  contractorId: string,
  documentIndex: number,
) =>
  get<Blob>(
    `/checkr/company/${contractorId}/report/document/${documentIndex}`,
    {},
    { responseType: "blob" },
  );

export const startCompanyContractorBackgroundCheck = async (
  contractorId: string,
  data: { packageId: string; paymentMethodId: string },
) => post<any>(`/checkr/company/${contractorId}/start`, data);
